import { render, staticRenderFns } from "./zhibiao.vue?vue&type=template&id=5d47dd0a&scoped=true&"
import script from "./zhibiao.vue?vue&type=script&lang=js&"
export * from "./zhibiao.vue?vue&type=script&lang=js&"
import style0 from "./zhibiao.vue?vue&type=style&index=0&id=5d47dd0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d47dd0a",
  null
  
)

export default component.exports